declare global {
  interface Window {
    fathom?: { trackEvent: (name: string) => void };
  }
}

export const enum FathomEvent {
  EXTERNAL_LINK_CLICK = "external_link_click",
  BUY = "buy",
}

/**
 * Sends an arbitrary event to Fathom Analytics. Will log a warning if Fathom
 * is not installed.
 */
export function trackEvent(event: string) {
  if (window.fathom) {
    window.fathom.trackEvent(event);
  } else {
    console.warn(`Attempting to track event ${event}, but Fathom is not installed.`);
  }
}
